import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ProductPage from "./pages/ProductPage";
import MecaniquePage from "./pages/MecaniquePage";
import FreePage from "./pages/FreePage";
import ContactPage from "./pages/ContactPage";
import SuccessPage from "./pages/SuccessPage";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/sonner";
import useSEO from "./hooks/useSEO";
import usePageTracker from "./hooks/usePageTracker";

const AppWrapper = ({ children }) => {
  useSEO();
  usePageTracker();
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppWrapper>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/sn4" element={<ProductPage productId="math-sec4-sn" />} />
            <Route path="/cst4" element={<ProductPage productId="math-sec4-cst" />} />
            <Route path="/mecanique" element={<MecaniquePage />} />
            <Route path="/gratuit" element={<FreePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </AppWrapper>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
